import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  CirclePlus,
  LayoutDashboard,
  LayoutTemplate,
  Sparkles,
} from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { BiButton } from '../components/ui/BiButton';
import { BiSurfaceCard } from '../components/ui/BiSurfaceCard';
import { BiDefaultSetState } from './functions/useBiDefaultSet';

/**
 * No dashboard at all yet: start from the recommended ones (when the
 * caller's role has them), ask the AI for a first chart, or create one.
 */
export const DashboardListEmpty = memo(
  ({
    recommended,
    onUseRecommended,
    onAskAi,
    onCreate,
  }: {
    recommended: BiDefaultSetState;
    onUseRecommended: () => void;
    onAskAi: () => void;
    onCreate: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const offered = recommended.kind !== 'none';
    return (
      <BiSurfaceCard
        style={{ padding: rpx(32), alignItems: 'center', gap: rpx(10) }}
      >
        <LayoutDashboard size={32} color={aiColors.amber} />
        <Typography.Text medium size={rpx(16)} color={aiColors.foreground}>
          还没有数据看板
        </Typography.Text>
        <Typography.Text
          size={rpx(13)}
          color={aiColors.mutedForeground}
          style={{ textAlign: 'center' }}
        >
          {offered
            ? '从为你的岗位准备的推荐看板开始，之后可以随时增删图表；也可以问 AI 或新建空看板。'
            : '问 AI 一个经营问题，把回答里的图表加到看板；或者先新建一个空看板。'}
        </Typography.Text>
        <View
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: rpx(8),
            marginTop: rpx(6),
          }}
        >
          {offered ? (
            <BiButton
              icon={LayoutTemplate}
              title={
                recommended.kind === 'creating' ? '正在创建…' : '使用推荐看板'
              }
              tone="primary"
              disabled={recommended.kind === 'creating'}
              onPress={onUseRecommended}
            />
          ) : null}
          <BiButton
            icon={Sparkles}
            title="问 AI 生成第一张图表"
            tone={offered ? undefined : 'primary'}
            onPress={onAskAi}
          />
          <BiButton icon={CirclePlus} title="新建看板" onPress={onCreate} />
        </View>
        {recommended.kind === 'failed' ? (
          <Typography.Text size={rpx(12)} color={aiColors.red}>
            {recommended.message}
          </Typography.Text>
        ) : null}
      </BiSurfaceCard>
    );
  },
);
